import React from 'react';
import { Award, Users, Clock, Shield } from 'lucide-react';
import { Card } from './ui/card';
import { WorkshopSlider } from './WorkshopSlider';
import { BrandLogoSlider } from './BrandLogoSlider';

export const About = () => {
  const stats = [
    { icon: Award, label: "Years Experience", value: "15+" },
    { icon: Users, label: "Happy Customers", value: "5000+" },
    { icon: Clock, label: "Hours of Service", value: "50000+" },
    { icon: Shield, label: "Warranty Guarantee", value: "100%" }
  ];

  const brands = [
    { 
      name: "BMW", 
      logo: "https://images.unsplash.com/photo-1680844540129-48dacc7d5d88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxCTVclMjBsb2dvfGVufDB8fHx8MTc3MTY1NTU4N3ww&ixlib=rb-4.1.0&q=85" 
    },
    { 
      name: "Mercedes-Benz", 
      logo: "https://images.unsplash.com/photo-1563694983011-6f4d90358083?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxNZXJjZWRlcyUyMEJlbnolMjBsb2dvfGVufDB8fHx8MTc3MTY1NTU4OHww&ixlib=rb-4.1.0&q=85" 
    },
    { 
      name: "Audi", 
      logo: "https://images.unsplash.com/photo-1610475426528-f5565ecca5bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxBdWRpJTIwbG9nb3xlbnwwfHx8fDE3NzE2NTU1ODl8MA&ixlib=rb-4.1.0&q=85" 
    },
    { 
      name: "Porsche", 
      logo: "https://images.unsplash.com/photo-1621460244115-aae28aad2b45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxQb3JzY2hlJTIwbG9nb3xlbnwwfHx8fDE3NzE2NTU1ODl8MA&ixlib=rb-4.1.0&q=85" 
    },
    { 
      name: "Volkswagen", 
      logo: "https://images.unsplash.com/photo-1637760561008-c7423e2237f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxWb2xrc3dhZ2VuJTIwbG9nb3xlbnwwfHx8fDE3NzE2NTU1OTB8MA&ixlib=rb-4.1.0&q=85" 
    }
  ];

  return (
    <section id="about" className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">About Us</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Your Trusted German Car Experts
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            With over 15 years of specialized experience, we're dedicated to keeping your German vehicle performing at its best.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Workshop Image Slider */}
          <div className="relative">
            <WorkshopSlider />
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Precision Engineering Meets Expert Care
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              At Think Mechanic, we understand that German vehicles are masterpieces of engineering that demand specialized knowledge and care. Our team of certified technicians has dedicated their careers to mastering the intricacies of BMW, Mercedes-Benz, Audi, Porsche, and Volkswagen vehicles.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              We combine cutting-edge diagnostic technology with hands-on expertise to deliver repairs and maintenance that meet the highest standards. From routine oil changes to complex engine rebuilds, we treat every vehicle with the precision and respect it deserves.
            </p>

            {/* Features */}
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="bg-red-600/20 p-2 rounded-lg mt-1">
                  <Award className="w-5 h-5 text-red-600" />
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold mb-1">Factory-Trained Technicians</h4>
                  <p className="text-gray-600 text-sm">Our team receives ongoing training on the latest German automotive technology.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-red-600/20 p-2 rounded-lg mt-1">
                  <Shield className="w-5 h-5 text-red-600" />
                </div>
                <div>
                  <h4 className="text-gray-900 font-semibold mb-1">Quality Guaranteed</h4>
                  <p className="text-gray-600 text-sm">All our work comes with comprehensive warranty coverage for your peace of mind.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
